import { Dto, DtoWithId } from "@mango/core";
import { Groep } from "../enums/groep";
import { Rubriek } from "./rubriek";
import { Taal } from './taal';
import { Tekst } from './tekst';

@Dto({fullName: "CIJBorculo.Logic.Voorblad"})
export class Voorblad extends DtoWithId {
	oldID: number;
	file: string;
	omschrijving: string;
	taal: Taal;
	rubriek: Rubriek;
	tekst_Onderzoek: Tekst;
	tekst_Onzekerheid: Tekst;
	tekst_Herhaal: Tekst;
	tekst_Omgeving: Tekst;
	groep: Groep;
	actief: boolean;
}